export const partnerName = ({ url, license }) => (url ? url : `qp_${license}`);

export const taggedLink = (props, location) =>
  `?utm_source=quality_page&utm_medium=referral&utm_campaign=${partnerName({
    ...props
  })}&utm_term=${location}`;
